import { Link } from "react-router-dom";
import { Instagram, Mail, MessageCircle } from "lucide-react";
import { Logo } from "@/components/site/Logo";
import { useFetch } from "@/hooks/useFetch";

export const Footer = () => {
  const { data } = useFetch("/settings/public", {});
  const s = data || {};
  const year = new Date().getFullYear();
  return (
    <footer className="relative overflow-hidden border-t border-white/10 bg-ink" data-testid="site-footer">
      <div className="mx-auto max-w-[1400px] px-5 pb-10 pt-20 sm:px-8">
        <div className="grid gap-12 md:grid-cols-12">
          <div className="md:col-span-5">
            <Logo />
            <p className="mt-5 max-w-sm text-haze">
              Fotografia de eventos com cobertura sem custo para quem organiza. Quem foi fotografado encontra, paga e baixa as próprias fotos.
            </p>
          </div>
          <div className="md:col-span-3">
            <p className="font-mono text-xs uppercase tracking-[0.2em] text-flash">Navegar</p>
            <ul className="mt-4 space-y-2.5 text-foreground/85">
              <li><Link to="/eventos" className="hover:text-flash" data-testid="footer-events-link">Galerias de eventos</Link></li>
              <li><Link to="/fotografos" className="hover:text-flash" data-testid="footer-photographers-link">Fotógrafos associados</Link></li>
              <li><Link to="/entrar" className="hover:text-flash" data-testid="footer-login-link">Área do fotógrafo</Link></li>
            </ul>
          </div>
          <div className="md:col-span-4">
            <p className="font-mono text-xs uppercase tracking-[0.2em] text-flash">Contato</p>
            <ul className="mt-4 space-y-2.5 text-foreground/85">
              {s.whatsapp && <li><a href={`https://wa.me/${s.whatsapp.replace(/\D/g, "")}`} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 hover:text-flash" data-testid="footer-whatsapp"><MessageCircle className="h-4 w-4" />{s.whatsapp}</a></li>}
              {s.contact_email && <li><a href={`mailto:${s.contact_email}`} className="inline-flex items-center gap-2 hover:text-flash" data-testid="footer-email"><Mail className="h-4 w-4" />{s.contact_email}</a></li>}
              {s.instagram && <li><a href={`https://instagram.com/${s.instagram.replace("@", "")}`} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 hover:text-flash" data-testid="footer-instagram"><Instagram className="h-4 w-4" />{s.instagram}</a></li>}
              {!s.whatsapp && !s.contact_email && !s.instagram && <li className="text-haze">Use o formulário de orçamento para falar com a gente.</li>}
            </ul>
          </div>
        </div>
        <p aria-hidden="true" className="pointer-events-none mt-16 select-none font-display text-[22vw] font-extrabold leading-[0.8] tracking-tighter text-outline opacity-40 sm:text-[17vw]">
          eutevilá
        </p>
        <div className="mt-8 flex flex-col justify-between gap-3 border-t border-white/10 pt-6 text-sm text-haze sm:flex-row">
          <span>© {year} Eutevila. Todos os direitos reservados.</span>
          <span className="font-mono text-xs">Eu te vi lá.</span>
        </div>
      </div>
    </footer>
  );
};
